
import { motion } from 'framer-motion';

const DiferenciaisSection = () => {
  const stats = [
    { number: '10+', label: 'Anos de Experiência' },
    { number: '500+', label: 'Projetos Entregues' },
    { number: '98%', label: 'Satisfação' },
    { number: '2', label: 'Regiões Atendidas' },
  ];

  const diferenciais = [
    {
      icon: 'ri-award-line',
      title: 'Expertise Técnica Comprovada',
      description: 'Equipe altamente qualificada com especializações e certificações nas principais normas técnicas e regulamentações.',
    },
    {
      icon: 'ri-time-line',
      title: 'Agilidade na Entrega',
      description: 'Processos otimizados e gestão eficiente garantem prazos cumpridos sem comprometer a qualidade técnica.',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Atendimento Personalizado',
      description: 'Consultoria dedicada com acompanhamento próximo em todas as etapas do projeto até a conclusão.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Conformidade Garantida',
      description: 'Todos os projetos e laudos seguem rigorosamente as normas técnicas vigentes e legislação aplicável.',
    },
  ];

  return (
    <section className="bg-white py-14 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-5"
          >
            <div className="inline-block bg-[#D4AF37]/10 text-[#D4AF37] px-4 py-2 rounded-full text-xs lg:text-sm font-semibold mb-4 lg:mb-6">
              Por que Engeporto
            </div>

            <h2 className="font-display font-bold text-2xl lg:text-5xl text-[#0A1628] mb-4 lg:mb-6 leading-tight">
              Autoridade Técnica Reconhecida
            </h2>

            <p className="text-sm lg:text-lg text-gray-600 leading-relaxed mb-8 lg:mb-10">
              Referência regional em engenharia especializada, oferecendo soluções técnicas de alto padrão com foco em resultados e conformidade normativa.
            </p>

            <div className="grid grid-cols-2 gap-6 lg:gap-8">
              {stats.map((stat) => (
                <motion.div
                  key={stat.label}
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5 }}
                  className="text-center lg:text-left"
                >
                  <div className="font-display font-bold text-4xl lg:text-6xl text-[#D4AF37] mb-1">
                    {stat.number}
                  </div>
                  <div className="text-[10px] lg:text-xs uppercase tracking-wider text-gray-500 font-semibold">
                    {stat.label}
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-7"
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-8">
              {diferenciais.map((diferencial, index) => (
                <motion.div
                  key={diferencial.title}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1, duration: 0.5 }}
                  className="bg-gray-50 rounded-2xl p-5 lg:p-8 hover:shadow-lg transition-all"
                >
                  <div className="w-11 h-11 lg:w-14 lg:h-14 flex items-center justify-center bg-[#D4AF37]/10 rounded-xl mb-4 lg:mb-6">
                    <i className={`${diferencial.icon} text-2xl lg:text-3xl text-[#D4AF37]`}></i>
                  </div>
                  <h3 className="font-display font-bold text-base lg:text-xl text-[#0A1628] mb-2 lg:mb-3">
                    {diferencial.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed text-xs lg:text-sm">
                    {diferencial.description}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default DiferenciaisSection;
